import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Close, HelpDrawer } from "@cmsgov/ds-medicare-gov";
import { FormattedHTMLMessage } from "react-intl-phraseapp";
import { HashLink } from "react-router-hash-link";
import routes from "../../app/routes";
import { sendTealiumEvent, useTranslate } from "../../helpers";

interface LandingPageMedigapHelpDrawerProps extends RouteComponentProps {
  setShowMedigapHelp: React.Dispatch<React.SetStateAction<boolean>>;
}

const LandingPageMedigapHelpDrawer: React.FC<LandingPageMedigapHelpDrawerProps> = ({
  setShowMedigapHelp,
  location,
}) => {
  const t = useTranslate();

  return (
    <div className="mct-c-help-drawer">
      <HelpDrawer
        heading={t("ooe_landing.looking_for")}
        onCloseClick={(): void => setShowMedigapHelp(false)}
        closeButtonText={<Close />}
        ariaLabel={t("close_help_drawer")}
      >
        <div className="ds-u-text-align--left">
          <p>{t("ooe_landing.medigap_explain_1")}</p>

          <p>
            <FormattedHTMLMessage id="ooe_landing.medigap_explain_2" />
          </p>

          <p>
            <FormattedHTMLMessage id="ooe_landing.medigap_explain_3" />
          </p>

          <div className="ds-u-text-align--center ds-u-margin-top--5">
            <HashLink
              to={`${routes.medigap.landingPage}${location.search}`}
              className="ds-c-button ds-c-button--big ds-c-button--primary"
              onClick={(): void => {
                sendTealiumEvent("Help Drawer", "Continue", "Medigap");
              }}
            >
              {t("ooe_landing.continue")}
            </HashLink>
          </div>
        </div>
      </HelpDrawer>
    </div>
  );
};

export default withRouter(LandingPageMedigapHelpDrawer);
